import Instructions from '../home/Instructions';

function Waiting(params) {
    return (
        <>
            <p className="waiting-for-user2-sign-in">Share this url with another player for them to join</p>
        </>
    )
}

export default Waiting;